import { isLocalStorageAvailable } from "utilities/Utilities";

class LocalStorageService {
  private static isAvailable = isLocalStorageAvailable();
  private static readonly NONCE_KEY:string = 'quiz_nonce';
  private static readonly QWID_KEY:string = 'qwid';
  private static readonly PASSCODE_VERIFIED_KEY:string = 'passcode_verified';

  public static setItem(key: string, value: string) {
    if (!this.isAvailable) return;
    try {
      localStorage.setItem(key, value);
    } catch {}
  }

  public static getItem(key: string): string | null {
    if (!this.isAvailable) return null;
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  public static removeItem(key: string) {
    if (!this.isAvailable) return;
    try {
      localStorage.removeItem(key);
    } catch {}
  }

  public static setNonce(quizNameSlug:string, nonce:string) {
    this.setItem(`${quizNameSlug}_${this.NONCE_KEY}`, nonce);
  }

  public static setQwid(qwid:string) {
    this.setItem(this.QWID_KEY, qwid);
  }

  public static getNonce(quizNameSlug:string):string | null {
    return this.getItem(`${quizNameSlug}_${this.NONCE_KEY}`);
  }

  public static getQwid():string | null {
    return this.getItem(this.QWID_KEY);
  }

  public static removeQwid(){
    this.removeItem(this.QWID_KEY);
  }

  public static clearStorage(quizNameSlug:string){
    this.removeItem(`${quizNameSlug}_${this.NONCE_KEY}`);
    this.removeItem(this.QWID_KEY);
  }

  public static setPasscodeVerified(groupSlug:string, passcodeHash:string) {
    this.setItem(`${groupSlug}_${this.PASSCODE_VERIFIED_KEY}`, passcodeHash);
  }

  public static isPasscodeVerified(groupSlug:string, passcodeHash:string):boolean {
    return this.getItem(`${groupSlug}_${this.PASSCODE_VERIFIED_KEY}`) === passcodeHash;
  }
}

export default LocalStorageService;